import React, { Component, useState } from 'react';

import Grid from '@mui/material/Grid2';

import { 
  AttachedTable,
  SummonUpgradeFeature, 
  UpgradableNumber
} from "@dndModels";
import { Feature } from '@models';
import { CREATURE_FEATURE_TYPES } from '@dndModels/Constants';

import CommonUtilities from '@utilities/common_utilities';
import DandDAPI from '@utilities/smart_api';

import CheckBox from "@components/input/CheckBox";
import UpgradableNumberBox from "@dndComponents/UpgradableNumberBox";
import CreatureLimitInput from '@dndComponents/limitations/CreatureLimitInput';
import FeatureInput from './FeatureInput';
import FeatureListInput from './FeatureListInput';
import ModalOrDrawer from '@components/display/ModalOrDrawer';

interface Props {
  obj: SummonUpgradeFeature;
  onChange: (changed: SummonUpgradeFeature) => void; 
  disabled?: boolean;
  attached_table?: AttachedTable;
}

const api = DandDAPI.getInstance();
const common_util = CommonUtilities.getInstance();

export default function SummonUpgradeFeatureInput({
  obj, disabled = false, attached_table, onChange
}: Props) {
  const [my_obj, setObj] = useState(obj);
  const [expanded, setExpanded] = useState<Feature | undefined>(undefined);
  const [ping, setPing] = useState(false);  
  
  const renderFeatures = () => {
    console.log("Rendering");
    return (
      <FeatureListInput 
        label="Feature"
        features={my_obj.features} 
        parent_type="Summon Upgrade"
        parent_id={my_obj._id}
        disabled={ disabled  }
        onExpand={(feature: Feature) => {
          if (my_obj.name !== "") {
            setExpanded(feature);
          }
        }}
        onAdd={() => {
          if (my_obj.name !== "" && api.user) {
            const new_obj = my_obj;
            const feature = new Feature();
            feature.parent_type = "SummonUpgradeFeature";
            feature.base_id = new_obj.id;
            new_obj.features.push(feature);
            setObj(new_obj); 
            setPing(!ping);
            setExpanded(feature);
            onChange(new_obj);
          }
        }}
      />
    );
  }

  const renderExpandedFeature = () => {
    if (expanded) {
      return (
        <FeatureInput 
          label="Feature"
          parent_name={obj.name}
          feature={expanded} 
          disabled={disabled}
          attached_table={attached_table}
          allowed_feature_types={[...CREATURE_FEATURE_TYPES,"Creature Type","Minion Ability"]}
          onChange={(changed: Feature) => {
            const new_obj = my_obj;
            new_obj.features = common_util.replaceInList(new_obj.features, changed.true_id, changed, "true_id");
            setExpanded(changed);
            setObj(new_obj); 
            setPing(!ping); 
            onChange(new_obj);
          }}
          onDelete={() => {
            const id = expanded.true_id;
            const new_obj = my_obj;
            const features = new_obj.features.filter(o => o.true_id !== id);
            new_obj.features = features;
            setExpanded(undefined);
            setObj(new_obj); 
            setPing(!ping);
            onChange(new_obj);
          }}
          onDone={(target: string) => {
            if (target === "base") {
              setExpanded(undefined);
            } else {
              setExpanded(undefined);
            }
          }}
        />
      );
    }
    return null;
  }

  const renderExtras = () => {
    return (
      <ModalOrDrawer 
        open={expanded !== undefined}
        full_page
        onClose={() => setExpanded(undefined) }>
        <>
          { renderExpandedFeature() }
        </>
      </ModalOrDrawer>
    );
  }

  return (
    <Grid container spacing={0} direction="row">
      <Grid size={12}>
        <CreatureLimitInput 
          obj={my_obj.limits} 
          disabled={disabled}
          onChange={changed => {
            const obj = my_obj;
            obj.limits = changed;
            setObj(obj);
            onChange(obj);
          }} 
        />
      </Grid>
      <Grid size={4}>
        <UpgradableNumberBox 
          name="Bonus HP" 
          value={my_obj.bonus_hp} 
          disabled={disabled}
          attached_table={attached_table}
          onChange={(value: UpgradableNumber) => {
            const new_obj = my_obj;
            new_obj.bonus_hp = value.clone();
            setObj(new_obj); 
            setPing(!ping);
            onChange(new_obj);
          }} 
        />
      </Grid>
      <Grid size={4}>
        <CheckBox 
          name="Per Hit Die" 
          value={my_obj.per_hit_die} 
          disabled={disabled}
          onChange={(value: boolean) => {
            const new_obj = my_obj;
            new_obj.per_hit_die = value;
            setObj(new_obj);
            setPing(!ping);
            onChange(new_obj);
          }} 
        />
      </Grid>
      <Grid size={4}>
        <CheckBox 
          name="Shared Resistances and Immunities" 
          value={my_obj.shared_res} 
          disabled={disabled}
          onChange={(value: boolean) => {
            const new_obj = my_obj;
            new_obj.shared_res = value;
            setObj(new_obj);
            setPing(!ping);
            onChange(new_obj);
          }} 
        />
      </Grid>
      {/* <Grid size={6}>
        <UpgradableNumberBox 
          name="Change Size" 
          value={my_obj.size_upgrade} 
          disabled={disabled}
          attached_table={attached_table}
          onChange={(value: UpgradableNumber) => {
            const new_obj = my_obj;
            new_obj.size_upgrade = value.clone();
            setObj(new_obj); 
            setPing(!ping);
            onChange(new_obj);
          }} 
        />
      </Grid> */}
      <Grid size={12}>
        { renderFeatures() }
      </Grid>
      { renderExtras() }
    </Grid>
  );
}
